import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {Tag, TagCategory} from "../../gen/api";

type Props = {
  isOpen: boolean
  onClose: () => void
  onSubmit: (cluster: Partial<TagCategory>, name: string) => void
  parent: Partial<TagCategory> | Partial<Tag>
};

/**
 * Dialog for adding a new group (also called search tags)
 *
 * @param isOpen Initial state of the dialog
 * @param onClose Callback for when the dialog is closed
 * @param onSubmit Callback for when the dialog is submitted
 * @param cluster The cluster to which the new group should be added
 * @constructor
 */
export default function AddGroupDialog({isOpen, onClose, onSubmit, parent}: Props) {
  const [name, setName] = useState("");

  const onSubmitWrapper = () => {
    onSubmit(parent, name);
    setName("");
    onClose();
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Tag zu '{parent.name}' hinzufügen</DialogTitle>
      <DialogContent>
        <TextField fullWidth variant="outlined" label="Tag Name" value={name} sx={{marginTop: 2}}
                   onChange={e => setName(e.target.value)}/>
      </DialogContent>
      <DialogActions style={{justifyContent: "space-between"}}>
        <Button fullWidth variant="contained" onClick={_ => onClose()}>Abbrechen</Button>
        <Button fullWidth disabled={!name} variant="contained" onClick={_ => onSubmitWrapper()}>Hinzufügen</Button>
      </DialogActions>
    </Dialog>
  );
}